import { Injectable } from "@angular/core";
import { ApiRootService } from "@modules/common/services/api-root.service";
import { CurrentCaseService } from "@modules/common/services/current-case.service";
import { CurrentEnvironmentService } from '@modules/common/services/current-environment.service';

@Injectable({
    providedIn: 'root'
})
export class ApiCallUrlService {
    constructor(
        private _apiRootService: ApiRootService,
        private _currentCaseService: CurrentCaseService,
        private _currentEnvironmentService: CurrentEnvironmentService
    ) { }

    public getUrl(path: string, includeEnvironmentAndCase: boolean = true): string {
        var url = this._apiRootService.getApiRoot();

        if (includeEnvironmentAndCase) {
            url = this.addUrlSegment(url, this._currentEnvironmentService.getCurrentEnvironmentName());
            url = this.addUrlSegment(url, this._currentCaseService.getCurrentCaseName());
        }

        if (url[url.length - 1] !== '/' && path[0] !== '/') {
            url += '/';
        }

        if (url[url.length - 1] === '/' && path[0] === '/') {
            path = path.substr(1);
        }

        url += path;
        url = encodeURI(url);
        return url.replace("'", "%27");
    }

    private addUrlSegment(url: string, newSegment: string): string {
        url = this.appendSlash(url);

        url += newSegment || '';

        url = this.appendSlash(url);

        if (url.length > 1 && url[0] === '/' && url[1] === '/') {
            url = url.substr(1);
        }

        return url;
    }

    private appendSlash(url: string): string {
        if (url[url.length - 1] !== '/') {
            url += '/';
        }

        return url;
    }
}
